
import Vue from 'vue';
import AddProjectDialog from "@/components/dialogs/AddProjectDialog.vue";
import FinishTaskDialog from "@/components/dialogs/FinishTaskDialog.vue";
import store from "@/store";
export const openDialog = (bizId : string | undefined, dialogName : string | null = null) : void => {
	const div = document.createElement("div");
	document.body.appendChild(div);
	let dialog : Vue | null = null;

	if (dialogName === undefined || dialogName === 'AddProjectDialog') {
		dialog = new Vue({
			store,
			render: h => h(AddProjectDialog,
				{
					props: { visible: true, projectId: bizId },
					on: {
						'update:visible': (newVisible : boolean) => {
							if (newVisible === false) {
								close();
							}
						}
					}
				}
			),
		});
	} else if (dialogName === 'FinishTaskDialog') {
		dialog = new Vue({
			store,
			render: h => h(FinishTaskDialog,
				{
					props: { visible: true, taskId: bizId },
					on: {
						'update:visible': (newVisible : boolean) => {
							if (newVisible === false) {
								close();
							}
						}
					}
				}
			),
		});
	}




	const close = () => {
		if (dialog != null) {
			document.body.removeChild(dialog.$el);
			dialog.$destroy();
		}
		div.remove();
	}
	if (dialog != null) {
		dialog.$mount(div);
	}

}